// Who PrintAWorld is and how to reach the studio, for schema and /llms.txt.
const BUSINESS_DESCRIPTION =
  'PrintAWorld is a custom fabrication studio in New York City (Glendale, Queens and Brooklyn) that makes one-offs, prototypes and small production runs: 3D printing, 3D modeling and scanning, custom figures, custom trophies, UV printing, laser engraving and cutting, and CNC routing. Projects are quoted after review and delivered anywhere in the United States.'
const BUSINESS_EMAIL = 'contact@prtwd.com'
const BUSINESS_PHONE = '+1-929-213-9604'

module.exports = { BUSINESS_DESCRIPTION, BUSINESS_EMAIL, BUSINESS_PHONE }
